import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'

export function useIsAuthenticated(): boolean {
  const { authenticated } = useSelector((state: IRootReducerState) => state.auth.user)

  return authenticated
}
